export default __webpack_public_path__ + "static/08-864c34d9b01f37ae0f777cccecd5619a.png";